var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dailyStreak"},[_c('div',{staticClass:"dailyStreak__container"},_vm._l((_vm.days),function(day,index){return _c('div',{staticClass:"dailyStreak__circle",class:_vm.getClassForDay(index + 1)})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }